/* eslint-disable import/prefer-default-export */
import type {
  SearchResultTableRow,
  AutoCompleteUsedInResp,
  SearchResultTableRow_UsedActionsEntry,
  SearchResultTableRow_TotalActionsEntry
} from '@src/endpoints/services/commonHdr.service'
import type {
  AutoCompleteRespTypeEnum,
  ResourceDetails
} from '@src/endpoints/services/graphQueryMgr.service'
import type { Graph } from '@src/components/vis.js.network.vis/models'

interface UsedActions extends SearchResultTableRow_UsedActionsEntry {
  ADMIN?: number
  READ?: number
  WRITE?: number
}

interface TotalActions extends SearchResultTableRow_TotalActionsEntry {
  ADMIN?: number
  READ?: number
  WRITE?: number
}

export interface SearchResult extends Omit<SearchResultTableRow, 'policies'> {
  //policies: Policies[]
  policies_cnt?: number
  policies_count?: number
  identity_account_name?: string
  resource_account_name?: string
  usedActions?: string
  totalActions?: string
  actions_str?: string
  region_name?: string
  identity_region_name?: string
  resource_region_name?: string
  used_actions?: UsedActions
  total_actions?: TotalActions
  items?: SearchResultTableRow[]
}

export interface ResourceItem extends ResourceDetails {}

export const invalidInput = 'INVALID INPUT'

export const defaultState = {
  options: [] as string[],
  graph: {} as Graph,
  result_table: [] as SearchResult[],
  identities: [] as ResourceItem[],
  objects: [] as ResourceItem[],
  policies: [] as ResourceItem[],
  resp_type: null as AutoCompleteRespTypeEnum,
  usage_resp: {} as AutoCompleteUsedInResp,
  has_next: false,
  has_prev: false,
  isPendingGraph: false
}
